<template>
	<v-file-input
		:key="vFileInputKey"
		:value="files"
		:rules="rules"
		:accept="accept"
		:height="height"
		:hide-details="hideDetails"
		:placeholder="placeholder"
		multiple
		prepend-icon=""
		prepend-inner-icon="mdi-paperclip"
		outlined solo flat dense
		@change="changeFile"
		@click:clear="clearFile"
	>
		<template v-slot:selection="slotProps">
			<v-chip
			:small="small"
				close
				@click:close="closeFile(slotProps.index)"
			>
				{{ slotProps.text }}
			</v-chip>
		</template>
	</v-file-input>
</template>

<script>
export default {
	name: 'UiMultipleFileInput',
	model: {
		prop: 'value',
	},
	props: {
		value: {
			type: Array,
			default: () => []
		},
		rules: {
			type: Array,
			default: () => []
		},
		accept: {
			type: [String, Array],
			default: ''
		},
		height: {
			type: [Number, String],
			default: undefined,
		},
		hideDetails: {
			type: [String, Boolean],
			default: false
		},
		small: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: undefined,
		},
	},
    data: function () {
        return {
            vFileInputKey: 0,
        };
    },
    computed: {
        files: {
            get: function () {
                return this.value;
            },
            set: function (val) {
                this.$emit('input', val);
            }
        },
    },
    methods: {
        changeFile: function (f) {
            if (!f) return;
            ([...f])
            .filter(function (file) {return !this.includesFile(file);}.bind(this))
            .forEach(function (file) {this.files.push(file);}.bind(this))
            ;
            this.vFileInputKey++;
        },
        clearFile: function () {
            this.files.splice(0);
        },
        closeFile: function (index) {
            this.files.splice(index, 1);
            this.vFileInputKey++;
        },
		includesFile (file) {
			let propertyKeys = ['lastModified', 'name', 'size', 'type'];
			if (this.$browser.isIE()) {
				propertyKeys.splice(0, 1, 'lastModifiedDate');
			}
			return this.files.some(f =>
				propertyKeys.every(key => f[key].toString() == file[key].toString())
			)
		},
    },
}
</script>